import { triggerFetchKycStatusApiCall, triggerValidatePanApiCall } from 'redux/actions';
import {
	TRIGGER_HOME_DETAILS_API_SUCCESS,
	TRIGGER_PAN_SAVE_API_SUCCESS,
	TRIGGER_COACHMARKS_SHOWN,
} from 'redux/actionTypes';
import { history, nativeHandler } from 'utils';
import store from '../../../store';

const initialState = {};

// export const locale[];
const setRoute = (data) => {
	if (data?.baseRoute?.includes('/')) {
		history.push(data?.baseRoute);
		setTimeout(() => {
			nativeHandler.removeLoader();
		}, 1000);
	} else {
		switch (data?.baseRoute) {
			case 'validatePan':
				store.dispatch(
					triggerValidatePanApiCall({
						panNumber: data?.panNumber.toUpperCase(),
						callSavePan: true,
						autoMateFlow: true,
					}),
				);
				break;

			case 'kyc':
				setTimeout(() => {
					nativeHandler.removeLoader();
				}, 1000);
				store.dispatch(triggerFetchKycStatusApiCall());
				break;

			default:
				break;
		}
	}
};
const HomeDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRIGGER_HOME_DETAILS_API_SUCCESS:
			action?.data?.baseRoute &&
				setTimeout(() => {
					setRoute(action?.data);
				}, 0);
			return {
				...state,
				...action.data,
			};
		case TRIGGER_PAN_SAVE_API_SUCCESS:
			return {
				...state,
				...action.data,
			};
		case TRIGGER_COACHMARKS_SHOWN:
			return {
				...state,
				coachmarksShown: true,
			};
		default:
			return state;
	}
};

export default HomeDetailsReducer;
